import ToggleBtn from "components/button/toggle";
import { ReactNode } from "react";
import "./formHead.scss";

type IProps = {
  title: string;
  sub?: string;
  children?: ReactNode;
};

export default function DetailFormHead({ title, sub, children }: IProps) {
  return (
    <div className="sub-head">
      <ul className="">
        <li className="flex items-center gap-2">
          <h3>{title}</h3>
          <sub className={sub ? "text-red-600 font-bold" : "hidden"}>{sub}</sub>
        </li>
        <li className="flex gap-1">
          <div>{children}</div>
          <ToggleBtn />
        </li>
      </ul>
    </div>
  );
}
